import { render, staticRenderFns } from "./ticket-number-top.vue?vue&type=template&id=6f553a77"
import script from "./ticket-number-top.vue?vue&type=script&lang=js"
export * from "./ticket-number-top.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f553a77')) {
      api.createRecord('6f553a77', component.options)
    } else {
      api.reload('6f553a77', component.options)
    }
    module.hot.accept("./ticket-number-top.vue?vue&type=template&id=6f553a77", function () {
      api.rerender('6f553a77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ticket-number-top.vue"
export default component.exports